import "./../css/archive.scss";
import $ from 'jquery';

$(document).ready(function () {
    $('.archive__search-icon').on('click', 'svg', function () {
        $(".archive-search").slideToggle('fast');
    });
    $('.archive-filter input').change(function () {
        var slugs = get_filters_archive();
        const params = new URLSearchParams(slugs);
        var url = window.location.href.split('?')[0];
        if (params.toString()) {
            window.location.href = url + "?" + params.toString();
        } else {
            window.location.href = url;
        }
    });
    $('.archive__clear-filters').on('click', function () {
        var url = window.location.href.split('?')[0];
        window.location.href = url;
    });
});

/*  pridobivanje izbranih filtrov*/
function get_filters_archive() {
    var slugs = {};
    $(".archive-filter").each(function () {
        var taxonomy = $(this).data("name");
        var temp = [];
        $(this).find("input[type='checkbox']:checked").each(function () {
            temp.push(parseInt($(this).attr("value")));
        })

        if ($(this).find("input[name=search]").val()) {
            temp.push($(this).find("input[name=search]").val());
        }
        if (temp.length > 0) {
            slugs["_" + taxonomy] = temp;
        }
    });

    if (('.post-filter-chip').length) {
        if (!$.isArray(slugs['_oznaka_blog'])) {
            slugs['_oznaka_blog'] = [];

        }
        $('.post-filter-chip:not(.hide)').each(function () {
            var chipId = parseInt($(this).attr('id'));
            if ($.inArray(chipId, slugs['_oznaka_blog']) === -1) {
                slugs['_oznaka_blog'].push(chipId);
            }
        })
    }

    return slugs;
}

//Blog archive filtri
$( ".post-filter-chip" ).on( "click", function() {
    $(this).addClass('hide');
    let selectedID = $(this).attr('id');
    let findCheckbox = document.querySelector("input[id='id_tag_" + selectedID + "']");
    $(findCheckbox).attr('checked', false);
    $( ".post-filter-item:first-child input").trigger('change');

});
